import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Tooltip from '../tooltip/tooltip'
import { PlusTag } from './tag-wrapper-plus-tag'
import { RemainingTagsContainer } from './tag-wrapper-remaining-tags-container'

import styles from './tag-wrapper.module.css'

const propTypes = {
    items: PropTypes.node,
    maxTooltipItems: PropTypes.number,
    tagClassName: PropTypes.string,
    tooltipClassName: PropTypes.string,
    tooltipPlacement: PropTypes.string
}

function TagWrapperTooltip({ items, maxTooltipItems, tagClassName, tooltipClassName, tooltipPlacement }) {
    const tooltipContent = <RemainingTagsContainer {...{ items, maxTooltipItems, tagClassName }} />

    const numItems = items.length
    return (
        <Tooltip
            className={cx(styles['tooltip'], tooltipClassName)}
            animate={false}
            placement={tooltipPlacement}
            content={tooltipContent}
        >
            <PlusTag {...{ numItems, tagClassName }} />
        </Tooltip>
    )
}

TagWrapperTooltip.propTypes = propTypes

export { TagWrapperTooltip }
